import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getGrauEscolaridade, cadastrarGrauEscolaridade, alterarGrauEscolaridade, excluirGrauEscolaridade } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
var GrausEscolaridadeEditar = function () {
    var services = {
        getItem: getGrauEscolaridade,
        cadastrarItem: cadastrarGrauEscolaridade,
        alterarItem: alterarGrauEscolaridade,
        excluirItem: excluirGrauEscolaridade,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.GRAUS_ESCOLARIDADE, paginaPermissao: FUNCIONALIDADES.GRAUS_ESCOLARIDADE, rota: ROUTES.GRAUS_ESCOLARIDADE, services: services });
};
export default GrausEscolaridadeEditar;
